module.exports = __webpack_public_path__ + "c7bca6af.svg";